import vConsole from "vconsole";

export const useLanguagePlugin = (vc: vConsole) => {
  const languages = [
    { code: "Arabic", label: "阿语" },
    { code: "Chinese", label: "简中" },
    { code: "Chinese_yy", label: "繁中" },
    { code: "English", label: "英语" },
    { code: "French", label: "法语" },
    { code: "German", label: "德语" },
    { code: "Italian", label: "意语" },
    { code: "Japanese", label: "日语" },
    { code: "Korean", label: "韩语" },
    { code: "Portuguese", label: "葡语" },
    { code: "Russian", label: "俄语" },
    { code: "Spanish", label: "西语" },
    { code: "Turkish", label: "土语" },
    { code: "Indonesian", label: "印尼" },
    { code: "Vietnamese", label: "越南" },
    { code: "Thai", label: "泰语" }
  ];
  const plugin = new vConsole.VConsolePlugin("language_plugin", "语言切换");

  plugin.on("renderTab", render => {
    render(`<h3>点击下方按钮切换页面语言</h3>`);
  });

  plugin.on("addTool", add => {
    add(
      languages.map(({ code, label }) => {
        return {
          name: label,
          global: false,
          onClick: () => {
            // 在URL中添加语言参数并刷新页面
            const url = new URL(window.location.href);
            url.searchParams.set("vLang", code);
            window.location.href = url.toString();
          }
        };
      })
    );
  });

  vc.addPlugin(plugin);
};
